import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = (id) => {
    // 1. Smooth scroll to the element
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

    // 2. Remove the hash from the URL without reloading
    window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
    
    // 3. Close mobile menu
    setIsMenuOpen(false);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="nav-logo" onClick={() => handleNavClick('home')}>
          <img
            src="/glitter-combined-logo.svg"
            alt="Glitter Logo"
            className="nav-logo-image"
          />
        </div>
        
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <button className="nav-link" onClick={() => handleNavClick('about')}>
              <img src="/icons/info-circle.svg" alt="About" className="nav-icon" />
              About Us
            </button>
          </li>
          <li className="nav-item">
            <button className="nav-link" onClick={() => handleNavClick('services')}>
              <img src="/icons/cogs.svg" alt="Services" className="nav-icon" />
              Powder Coating Services
            </button>
          </li>
          <li className="nav-item">
            <button className="nav-link" onClick={() => handleNavClick('fabrication-services')}>
              <img src="/icons/tools.svg" alt="Fabrication" className="nav-icon" />
              Fabrication Services
            </button>
          </li>
          <li className="nav-item">
            <button className="nav-link" onClick={() => handleNavClick('contact')}>
              <img src="/icons/email.svg" alt="Contact" className="nav-icon" />
              Contact Us
            </button>
          </li>
        </ul>
        
        <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 